import {EntityData, field} from "@fedeltapointofsale/data-client";

export class StockLevelData extends EntityData<StockLevelData> {
    @field outletStockID: number;
}
